import store from '../configureStore';

/**
 * Api prefix constants
 */
const baseUrl = process.env.REACT_APP_URLS_BASE_URL;
const mwBaseUrl = process.env.REACT_APP_URLS_MW_BASE_URL;
const regBaseUrl = process.env.REACT_APP_URLS_REG_BASE_URL;
export const trackerUrl = 'https://tr.recyclecoach.com:3000/tr';
export const googleApiKey = process.env.REACT_APP_GOOGLE_API_KEY;
export const campaignBaseUrl = process.env.REACT_APP_URLS_CAMPAINGN_BASE_URL;
export const webCampaignBaseUrl = process.env.REACT_APP_URLS_WEB_CAMPAINGN_BASE_URL;
// const adminBaseUrl = 'http://staging.admin.my-waste.mobi';
// const adminUrl = 'https://admin.my-waste.mobi';
// const tmpBaseUrl = 'https://deliver.my-waste.mobi';
// const campaignImageBaseUrl = 'https://cdn.recyclecoach.com/campaigns';


/**
 * @private
 */
function updateQueryStringParameter(uri, key, value) {
  const re = new RegExp(`([?&])${key}=.*?(&|$)`, 'i');
  const separator = uri.indexOf('?') !== -1 ? '&' : '?';
  if (uri.match(re)) {
    return uri.replace(re, `$1${key}=${value}$2`);
  }
  return `${uri + separator + key}=${value}`;
}


/**
 * @private
 * Api combination function
 */
const buildEndpoint = (prefix, path) => {
  const state = store.store.getState();
  const url = `${prefix}/${path}`;
  if (state.config.langs.length) {
    const { lang } = state.config;
    return updateQueryStringParameter(url, 'lang', lang);
  }
  return url;
};


/**
 * Api connstructors
 */
export default {
  wgwMaterialGroupApi: (localityId) => buildEndpoint(baseUrl, `${localityId}/wgw-group-list.json`),
  materialsByGroupId: (localityId, groupId) => buildEndpoint(baseUrl, `${localityId}/wgw-group-list.json?wgw_group_id=${groupId}`),
  wgwMaterialListApi: (localityId) => buildEndpoint(baseUrl, `${localityId}/material-list.json`),
  searchMaterialByTerm: (localityId, term) => buildEndpoint(baseUrl, `${localityId}/material-list.json?q=${term}`),
  materialDetailsApi: (localityId, matId) => buildEndpoint(baseUrl, `${localityId}/material/${matId}.json`),
  packageDownload: (project, district) => `${mwBaseUrl}/content-format-2/${project}-${district}/js/no-collection-data.js`,
  getGeneralPage: (localityId, link) => buildEndpoint(baseUrl, `${localityId}/${link.replace('page', 'json')}`),
  getEventsApi: (localityId, matId) => buildEndpoint(baseUrl, `${localityId}/drop-event-list.json?matId=${matId}`),
  getDeposApi: (localityId, matId, location) => buildEndpoint(baseUrl, `${localityId}/drop-depot-list.json?matId=${matId}${location}`),
  getEventDetailsApi: (localityId, matId) => buildEndpoint(baseUrl, `${localityId}/drop-event/${matId}.json`),
  getDepoDetailsApi: (localityId, matId) => buildEndpoint(baseUrl, `${localityId}/drop-depot/${matId}.json`),
  setupFromPluginIdApi: () => `${regBaseUrl}/plugin/getinfo`,
  campaignUrl: ({
    projectId, districtId, uuid, lang, zones, campaignSource
  }) => `${webCampaignBaseUrl}/?projectId=${projectId}&districtId=${districtId}&uuid=${uuid}&lang=${lang}&zones=${zones}&campaignSource=${campaignSource}`,
  activeCampaignUrl: ({ projectId, districtId }) => `${campaignBaseUrl}/campaigns/active-campaign/${projectId}/${districtId}`,
  imageUrl: (localityId, path) => `https://cdn.recyclecoach.com/gallery/${path}`
};
